import React, { useRef, useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Form } from "react-bootstrap";
// import SelectStudentModal from "../AdminAttendanceEntry/SelectStudentModal";
import { ApiUrl } from "../../../ApiUrl";
import SelectStudentFeeModal from "../FeeStudentModal/SelectStudentFeeModal";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";

const AdmAttendanceEntry = () => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [classId, setClassId] = useState(null);
  const [sectionId, setSectionId] = useState(null);
  const [classOptions, setClassOptions] = useState([]);
  const [studentId, setStudentId] = useState("");
  const [sectionOptions, setSectionOptions] = useState([]);
  const [studentName, setStudentName] = useState("");
  const [selectedFeePeriod, setSelectedFeePeriod] = useState("");
  const [feePeriod, setFeePeriod] = useState(null);
  const [showUnpaid, setShowUnpaid] = useState(false);
  const [transportData, setTransportData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pickupPoint, setPickupPoint] = useState(null);
  const [pickupPoints, setPickupPoints] = useState([]);
  const orgId = localStorage.getItem("orgId");
  const branchId = localStorage.getItem("branchId");
  const academicyearId = localStorage.getItem("academicSessionId");
  const [showUnpaidFee, setShowUnpaidFee] = useState(false);

  const handleClear = () => {
    setSelectedFeePeriod("");
    setStudentName("");
    // setFeePeriod([]);
    setPickupPoint("");
    setClassId(null);
    setSectionId("");
    setTransportData("");
    setShowUnpaidFee("");
  };

  const handleClose = () => {
    navigate("/admin/dashboard");
  };

  const handleOpenModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  // const handleSelectStudent = (selectedStudent) => {
  //   const fullName = [
  //     selectedStudent.studentBasicDetails.first_name || "",
  //     selectedStudent.studentBasicDetails.middle_name || "",
  //     selectedStudent.studentBasicDetails.last_name || "",
  //   ]
  //     .filter(Boolean)
  //     .join(" ");

  //   // Set studentId when selecting a student (we will use this for the search)
  //   setStudentId(selectedStudent.studentBasicDetails.id || "");
  //   setStudentName(fullName);
  //   setClassId(selectedStudent.studentBasicDetails.addmitted_class || null);
  //   setSectionId(selectedStudent.studentBasicDetails.addmitted_section || null);

  //   handleCloseModal();
  // };


  const handleSelectStudent = (selectedStudent) => {
    // Build full name from top-level fields
    const fullName = [
      selectedStudent.studentname || "", // use studentname from API
    ]
      .filter(Boolean)
      .join(" ");

    // Set studentId (use studentId from API)
    setStudentId(selectedStudent.studentId || "");

    // Set student name for display
    setStudentName(fullName);

    // Set classId and sectionId
    setClassId(selectedStudent.classId || null);
    setSectionId(selectedStudent.sectionId || null);

    handleCloseModal();
  };

  useEffect(() => {
    const fetchSectionData = async () => {
      if (!classId) {
        setSectionOptions([]); // Clear sections if no class selected
        return;
      }

      console.log("Fetching sections for classId:", classId); // Debugging

      try {
        const response = await fetch(
          `${ApiUrl.apiurl}ClassSectionBind/GetAllSectionBindWithClass/${classId}`
        );
        const data = await response.json();

        console.log("Section API response:", data); // Debugging

        if (data.message === "success") {
          const formattedSections = data.data.map((sectionItem) => ({
            value: sectionItem.section_id,
            label: sectionItem.sectionname,
          }));
          setSectionOptions(formattedSections);
        } else {
          console.error("Failed to fetch sections: ", data.message);
          setSectionOptions([]);
        }
      } catch (error) {
        console.error("Error fetching section data:", error);
        setSectionOptions([]);
      }
    };

    fetchSectionData();
  }, [classId]);

  useEffect(() => {
    const fetchClassData = async () => {
      try {
        const response = await fetch(`${ApiUrl.apiurl}Class/GetAllClass`);
        const data = await response.json();

        if (data.message === "Success") {
          const formattedClasses = data.data.map((classItem) => ({
            value: classItem.id,
            label: classItem.classname,
          }));
          setClassOptions(formattedClasses);
        } else {
          console.error("Failed to fetch classes: ", data.message);
        }
      } catch (error) {
        console.error("Error fetching class data:", error);
      }
    };
    fetchClassData();
  }, []);

  useEffect(() => {
    fetchFeePeriods();
  }, []);

  const fetchFeePeriods = async () => {
    try {
      const response = await fetch(
        `${ApiUrl.apiurl}Periods/GetAllPeriods/`
      );
      const result = await response.json();

      if (response.ok && Array.isArray(result.data)) {
        const formattedPeriods = result.data.map((period) => ({
          value: period.id,
          label: period.period_name,
        }));
        setFeePeriod(formattedPeriods);
      } else {
        console.error("Failed to fetch fee periods:", result.message);
        setFeePeriod([]); // Set as empty array in case of failure
      }
    } catch (error) {
      console.error("Error fetching fee periods:", error);
      setFeePeriod([]); // Set as empty array in case of error
    }
  };

  useEffect(() => {
    const fetchPickupPoints = async () => {
      try {
        const response = await fetch(
          `${ApiUrl.apiurl}PICKUP_POINT/pickuppointlist/${orgId}/${branchId}/`
        );
        const data = await response.json();

        if (data.message === "Success" && Array.isArray(data.data)) {
          // Transforming the data for react-select
          const formattedPickupPoints = data.data.map((point) => ({
            value: point.id, // Store ID as value
            // label: `${point.pickup_point_name} (₹${point.amount})`,
            label: `${point.pickup_point_name} `,
          }));
          setPickupPoints(formattedPickupPoints);
        }
      } catch (error) {
        console.error("Error fetching pickup points:", error);
      }
    };

    if (orgId && branchId) {
      fetchPickupPoints();
    }
  }, [orgId, branchId]);

  // Function to Export Data to Excel
  const handleSearch = async () => {
    setLoading(true);

    // Required parameters
    const queryParams = new URLSearchParams({
      academicyearId: academicyearId,
      org_id: orgId,
      branch_id: branchId,
    });

    // Optional parameters (added only if they have a value)
    if (studentId) queryParams.append("studentId", studentId);
    if (classId) queryParams.append("classId", classId);
    if (sectionId) queryParams.append("sectionId", sectionId);
    if (pickupPoint) queryParams.append("pickup_pointId", pickupPoint);
    if (selectedFeePeriod) queryParams.append("feeappfrom", selectedFeePeriod);

    // Always include 'paid_unpaid' based on checkbox selection
    queryParams.append("paid_unpaid", showUnpaidFee ? "true" : "false");

    try {
      const response = await fetch(
        `${
          ApiUrl.apiurl
        }Transport/TransportChargesCalculateBasedOnStudent/?${queryParams.toString()}`
      );
      const data = await response.json();

      if (data.message === "success" && Array.isArray(data.data)) {
        setTransportData(data.data);
      } else {
        setTransportData([]);
      }
    } catch (error) {
      console.error("Error fetching transport fees:", error);
      setTransportData([]);
    } finally {
      setLoading(false);
    }
  };

  const exportToExcel = () => {
    if (transportData.length === 0) {
      alert("No data available to export.");
      return;
    }

    const worksheet = XLSX.utils.json_to_sheet(
      transportData.map((item, index) => ({
        "Sr.No": index + 1,
        "Student Name": item.student_name,
        "Admission No": item.school_admission_no,
        Class: item.classname,
        Section: item.sectionname,
        "Father Name": item.father_name,
        "Pick Up Point": item.pick_up_point,
        "Total Transport Fees": item.total_fees,
        "Fees Paid": item.paid_fees,
        Balance: item.total_fees - item.paid_fees,
      }))
    );

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Transport Data");

    // Save the Excel file
    XLSX.writeFile(workbook, "TransportData.xlsx");
  };

  const fetchViewPDF = async (student_id, feeappfrom) => {
    try {
      const response = await fetch(
        `${ApiUrl.apiurl}Transport/MonthlyElemetWiseStudentFees/?student_id=${student_id}&academicyearId=${academicyearId}&org_id=${orgId}&branch_id=${branchId}&feeappfrom=${feeappfrom}`
      );

      const result = await response.json();

      if (result.message === "success") {
        generatePDF(result.data);
      } else {
        alert(result.message || "Failed to fetch data");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const generatePDF = (data) => {
    const doc = new jsPDF();
    doc.setFontSize(16);
    doc.text("Monthly Fee Report", 14, 15);

    let startY = 25;
    const groupedData = groupByMonth(data);
    let totalFees = 0,
      totalPaid = 0,
      totalBalance = 0,
      totalDiscount = 0;

    Object.entries(groupedData).forEach(([month, records]) => {
      let subtotalAmount = 0,
        subtotalPaid = 0,
        monthDiscount = 0;

      // **Filter out "DISCOUNT" rows and calculate total discount**
      const filteredRecords = records.filter((item) => {
        if (item.element_name === "DISCOUNT") {
          monthDiscount += item.total_paid_amount; // Add discount amount for the month
          totalDiscount += item.total_paid_amount; // Add to total discount
          return false; // Exclude from table
        }
        return true;
      });

      if (filteredRecords.length === 0) return; // Skip if no data after filtering

      // Month Header Row (Gray Background)
      doc.autoTable({
        startY: startY,
        head: [[`Fee Period: ${month}`]],
        theme: "grid",
        styles: { fillColor: [200, 200, 200] },
      });

      // Table Data for Each Month
      const tableData = filteredRecords.map((item) => {
        subtotalAmount += item.total_amount;
        subtotalPaid += item.total_paid_amount;
        return [
          item.element_name,
          item.total_amount.toFixed(2),
          item.total_paid_amount.toFixed(2),
          (item.total_amount - item.total_paid_amount).toFixed(2), // Balance per row
        ];
      });

      // Table with Headings
      doc.autoTable({
        startY: doc.lastAutoTable.finalY + 5,
        head: [["Fee Element", "Total Amt", "Paid", "Balance"]],
        body: tableData,
        theme: "grid",
      });

      // Subtotal Row
      doc.autoTable({
        startY: doc.lastAutoTable.finalY + 2,
        body: [
          [
            "Total",
            subtotalAmount.toFixed(2),
            subtotalPaid.toFixed(2),
            (subtotalAmount - subtotalPaid - monthDiscount).toFixed(2), // Updated balance formula per month
          ],
        ],
        styles: { fontStyle: "bold" },
        theme: "grid",
      });

      totalFees += subtotalAmount;
      totalPaid += subtotalPaid;
      startY = doc.lastAutoTable.finalY + 10;
    });

    // **Calculate Final Balance**
    totalBalance = totalFees - totalPaid - totalDiscount;

    // Final Summary
    doc.autoTable({
      startY: startY,
      body: [
        ["Total Fees", totalFees.toFixed(2)],
        ["Total Paid", totalPaid.toFixed(2)],
        ["Total Discount", totalDiscount.toFixed(2)], // 👈 Moved up for clarity
        ["Final Balance", totalBalance.toFixed(2)], // 👈 Updated Balance Calculation
      ],
      theme: "grid",
      styles: { fontStyle: "bold", halign: "right" },
    });

    // Open PDF in a new tab
    const pdfBlob = doc.output("blob");
    const pdfURL = URL.createObjectURL(pdfBlob);
    window.open(pdfURL);
  };

  const groupByMonth = (data) => {
    return data.reduce((acc, item) => {
      if (!acc[item.month]) {
        acc[item.month] = [];
      }
      acc[item.month].push(item);
      return acc;
    }, {});
  };

  const handleCheckboxChange = (e) => {
    setShowUnpaidFee(e.target.checked);
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="card p-0">
            <div className="card-body">
              <p
                style={{
                  marginBottom: "0px",
                  textAlign: "center",
                  fontSize: "20px",
                  fontWeight: "700",
                }}
              >
                STUDENT TRANSPORT FEE
              </p>

              <div className="row mb-3 mt-3 mx-0">
                <div className="col-12  d-flex flex-wrap gap-2">
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleSearch}
                  >
                    Search
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={exportToExcel}
                  >
                    Export to Excel
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleClear}
                  >
                    Clear
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleClose}
                  >
                    Close
                  </button>
                </div>
              </div>

              {/* SearchFeild */}
              <div className="row mt-3 mx-2">
                <div className="col-12 custom-section-box">
                  <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center">
                    {/* <div className="row flex-grow-1">
                      <div className="col-md-3 mb-0">
                        <label htmlFor="student-name" className="form-label">
                          Student Name
                        </label>
                        <div className="d-flex align-items-center">
                          <input
                            type="text"
                            id="student-name"
                            className="form-control detail"
                            placeholder="Enter student name"
                            value={studentName}
                            onChange={(e) => setStudentName(e.target.value)}
                            disabled
                          />
                          <button
                            type="button"
                            className="btn btn-primary ms-0 mb-0 mt-0"
                            onClick={handleOpenModal}
                            style={{ width: "50px", padding: "3px" }}
                          >
                            ...
                          </button>
                        </div>
                      </div>
                      <SelectStudentFeeModal
                        show={showModal}
                        handleClose={handleCloseModal}
                        onSelectStudent={handleSelectStudent}
                      />

                      <div className="col-md-3">
                        <label style={{ fontWeight: "700" }}>Class</label>
                        <Select
                          options={classOptions}
                          classNamePrefix="react-select"
                          isClearable={true}
                          placeholder="Select Class"
                          value={
                            classOptions.find(
                              (option) => option.value === classId
                            ) || null
                          }
                          onChange={(selectedOption) =>
                            setClassId(
                              selectedOption ? selectedOption.value : null
                            )
                          }
                        />
                      </div>

                      <div className="col-md-3">
                        <label style={{ fontWeight: "700" }}>Section</label>
                        <Select
                          options={sectionOptions}
                          classNamePrefix="react-select"
                          isClearable={true}
                          placeholder="Select Section"
                          value={
                            sectionOptions.find(
                              (option) => option.value === sectionId
                            ) || null
                          }
                          onChange={(selectedOption) => {
                            console.log(
                              "Selected sectionId:",
                              selectedOption ? selectedOption.value : null
                            );
                            setSectionId(
                              selectedOption ? selectedOption.value : null
                            );
                          }}
                        />
                      </div>

                      <div className="col-md-3">
                        <label htmlFor="pick-up-point" className="form-label">
                          Pick Up Point
                        </label>
                        <Select
                          options={pickupPoints}
                          classNamePrefix="react-select"
                          placeholder="Select Pick Up Point"
                          isClearable
                          value={
                            pickupPoints.find(
                              (option) => option.value === pickupPoint
                            ) || null
                          }
                          onChange={(selectedOption) => {
                            console.log(
                              "Selected Pickup Point ID:",
                              selectedOption?.value
                            );
                            setPickupPoint(
                              selectedOption ? selectedOption.value : null
                            );
                          }}
                        />
                      </div>

                      <div className="col-md-3">
                        <label htmlFor="fee-period" className="form-label">
                          Fee Period
                        </label>
                        <Select
                          options={feePeriod}
                          isClearable={true}
                          placeholder="Select Fee Period"
                          value={
                            feePeriod?.find(
                              (option) => option.value === selectedFeePeriod
                            ) || null
                          }
                          onChange={(selectedOption) =>
                            setSelectedFeePeriod(
                              selectedOption ? selectedOption.value : null
                            )
                          }
                        />
                      </div>

                      <div className="col-12 col-md-3 mb-1">
                        <br />
                        <label htmlFor="club" className="form-label">
                          <Form.Check
                            type="checkbox"
                            label="Show Unpaid Fee"
                            checked={showUnpaidFee}
                            onChange={handleCheckboxChange}
                          />
                        </label>
                      </div>
                    </div> */}

                    <div className="row flex-grow-1">
                      <div className="col-md-3 mb-0">
                        <label htmlFor="student-name" className="form-label">
                          Student Name
                        </label>
                        <div className="d-flex align-items-center">
                          <input
                            type="text"
                            id="student-name"
                            className="form-control detail"
                            placeholder="Enter student name"
                            // ref={studentNameRef}
                            value={studentName}
                            onChange={(e) => setStudentName(e.target.value)}
                            disabled
                          />
                          <button
                            type="button"
                            className="btn btn-primary ms-0 mb-0 mt-0"
                            onClick={handleOpenModal}
                            style={{ width: "50px", padding: "3px" }}
                          >
                            ...
                          </button>
                        </div>
                      </div>
                      <SelectStudentFeeModal
                        show={showModal}
                        handleClose={handleCloseModal}
                        onSelectStudent={handleSelectStudent}
                      />

                      <div className="col-md-3">
                        <label htmlFor="class" className="form-label">
                          Class
                        </label>
                        <Select
                          options={classOptions}
                          className="detail"
                          classNamePrefix="react-select"
                          placeholder="Select Class"
                          value={
                            classOptions.find(
                              (option) => option.value === classId
                            ) || null
                          } // Match the selected class
                          onChange={(selectedOption) =>
                            setClassId(
                              selectedOption ? selectedOption.value : null
                            )
                          }
                        />
                      </div>

                      <div className="col-md-3">
                        <label htmlFor="section" className="form-label">
                          Section
                        </label>
                        <Select
                          options={sectionOptions}
                          className="detail"
                          classNamePrefix="react-select"
                          placeholder="Select Section"
                          value={
                            sectionOptions.find(
                              (option) => option.value === sectionId
                            ) || null
                          }
                          onChange={(selectedOption) => {
                            console.log(
                              "Selected sectionId:",
                              selectedOption ? selectedOption.value : null
                            ); // Debugging
                            setSectionId(
                              selectedOption ? selectedOption.value : null
                            );
                          }}
                        />
                      </div>

                      <div className="col-md-3">
                        <label htmlFor="pick-up-point" className="form-label">
                          Pick Up Point
                        </label>
                        <Select
                          options={pickupPoints}
                          className="detail"
                          classNamePrefix="react-select"
                          placeholder="Select Pick Up Point"
                          value={
                            pickupPoints.find(
                              (option) => option.value === pickupPoint
                            ) || null
                          }
                          onChange={(selectedOption) => {
                            console.log(
                              "Selected Pickup Point ID:",
                              selectedOption?.value
                            ); // Debugging
                            setPickupPoint(
                              selectedOption ? selectedOption.value : null
                            );
                          }}
                        />
                      </div>

                      <div className="col-md-3 mb-3">
                        <label htmlFor="fee-period" className="form-label">
                          Fee Period
                        </label>
                        <Select
                          options={feePeriod}
                          className="detail"
                          // classNamePrefix="react-select"
                          placeholder="Select Fee Period"
                          value={
                            feePeriod?.find(
                              (option) => option.value === selectedFeePeriod
                            ) || null
                          } // Ensure feePeriod is an array
                          onChange={(selectedOption) =>
                            setSelectedFeePeriod(
                              selectedOption ? selectedOption.value : null
                            )
                          }
                        />
                      </div>

                      {/* <div className="col-12 col-md-3 mb-1">
                        <br></br>
                        <label htmlFor="club" className="form-label">
                          <Form.Check type="checkbox" label="Show Unpaid Fee" />
                        </label>
                      </div> */}
                      <div className="col-12 col-md-3 mb-1">
                        <br />
                        <label htmlFor="club" className="form-label">
                          <Form.Check
                            type="checkbox"
                            label="Show Unpaid Fee"
                            checked={showUnpaidFee}
                            onChange={handleCheckboxChange}
                          />
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Table
            <div className="row">
              <div className="col-12">
                <div className="table-responsive">
                  <table className="table table-bordered table-hover">
                    <thead>
                      <tr>
                        <th>Sr.No</th>
                        <th>Student Name</th>
                        <th>Admission No</th>
                        <th>Class</th>
                        <th>Section</th>
                        <th>Father Name</th>
                        <th>Pick Up Point</th>
                        <th>Total Transport Fees</th>
                        <th>Fees Paid</th>
                        <th>Balance</th>
                        <th>View</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="11" className="text-center">
                            Loading...
                          </td>
                        </tr>
                      ) : transportData.length > 0 ? (
                        transportData.map((item, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{item.student_name}</td>
                            <td>{item.school_admission_no}</td>
                            <td>{item.classname}</td>
                            <td>{item.sectionname}</td>
                            <td>{item.father_name}</td>
                            <td>{item.pick_up_point}</td>
                            <td>{item.total_fees}</td>
                            <td>{item.paid_fees}</td>
                            <td>{item.total_fees - item.paid_fees}</td>
                            <td>
                              <button
                                className="btn btn-info btn-sm"
                                disabled={item.paid_fees === 0}
                                style={{
                                  opacity: item.paid_fees === 0 ? 0.5 : 1,
                                  cursor: item.paid_fees === 0 ? "not-allowed" : "pointer",
                                }}
                                title={item.paid_fees === 0 ? "View is disabled until amount is paid" : "View details"}
                                onClick={() =>
                                  item.paid_fees > 0 && fetchViewPDF(item.student_id, item.feeappfrom)
                                }
                              >
                                View
                              </button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="11" className="text-center">
                            No Data Found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div> */}

            {/* Table */}

            <div className="col-12">
              <div className="table-responsive">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Sr.No</th>
                      <th>Student Name</th>
                      <th>Admission No</th>
                      <th>Class</th>
                      <th>Section</th>
                      <th>Father Name</th>
                      <th>Pick Up Point</th>
                      <th>Total Transport Fees</th>
                      <th>Fees Paid</th>
                      <th>Balance</th>
                      <th>View</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr>
                        <td colSpan="11" className="text-center">
                          Loading...
                        </td>
                      </tr>
                    ) : transportData.length > 0 ? (
                      transportData.map((item, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{item.student_name}</td>
                          <td>{item.school_admission_no}</td>
                          <td>{item.classname}</td>
                          <td>{item.sectionname}</td>
                          <td>{item.father_name}</td>
                          <td>{item.pick_up_point}</td>
                          <td>{item.total_fees}</td>
                          <td>{item.paid_fees}</td>
                          <td>{item.total_fees - item.paid_fees}</td>
                          <td>
                            <button
                              className="btn btn-info btn-sm"
                              disabled={item.paid_fees === 0}
                              style={{
                                opacity: item.paid_fees === 0 ? 0.5 : 1,
                                cursor: item.paid_fees === 0 ? "not-allowed" : "pointer",
                              }}
                              title={item.paid_fees === 0 ? "View is disabled until amount is paid" : "View details"}
                              onClick={() =>
                                item.paid_fees > 0 && fetchViewPDF(item.student_id, item.feeappfrom)
                              }
                            >
                              View
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="11" className="text-center">
                          No Data Found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdmAttendanceEntry;
